/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_WindowsInputs */

const en_cad_download_windows = /** @type {(inputs: Cad_Download_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows`)
};

/**
* | output |
* | --- |
* | "Windows" |
*
* @param {Cad_Download_WindowsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_windows = /** @type {((inputs?: Cad_Download_WindowsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_WindowsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_windows(inputs)
});
export { cad_download_windows as "cad.download.windows" }